import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  amount: () => __(translations.commercialDocumentComponents.amount, 'Amount'),
  option: () => __(translations.commercialDocumentComponents.option, 'Option'),
};
